export default "__VITE_ASSET__Bi0Tao1b__"